<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Esame Neurologico All'Ingresso" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataEsameNeurologicoIngresso.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataEsameNeurologicoIngresso.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataEsameNeurologicoIngresso: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataEsameNeurologicoIngresso: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaEsameNeurologicoIngresso: "/rsaschedarelazionesanitariaesameneurologicoingresso",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaEsameNeurologicoIngresso() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaEsameNeurologicoIngresso + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaEsameNeurologicoIngressoSuccess, me.resultResponseSchedaRelazioneSanitariaEsameNeurologicoIngressoError);
        },

        resultResponseSchedaRelazioneSanitariaEsameNeurologicoIngressoSuccess(response) {
            let me = this;
            me.jsonDataEsameNeurologicoIngresso = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaEsameNeurologicoIngressoError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataEsameNeurologicoIngresso = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onEsameNeurologicoIngresso() {
            let me = this;
            me.jsonDataEsameNeurologicoIngresso.idAccettazione = me.idAccettazione;
            if (!me.jsonDataEsameNeurologicoIngresso.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaEsameNeurologicoIngresso, me.jsonDataEsameNeurologicoIngresso, me.saveSchedaRelazioneSanitariaEsameNeurologicoIngressoSuccessResponse, me.saveSchedaRelazioneSanitariaEsameNeurologicoIngressoErrorResponse);
        },
        saveSchedaRelazioneSanitariaEsameNeurologicoIngressoSuccessResponse() {},
        saveSchedaRelazioneSanitariaEsameNeurologicoIngressoErrorResponse() {
            console.error("Errore nel salvataggio esame neurologico ingresso:");
        },
    },
};
</script>
